import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axiosInstance from '../interceptor/intercetptor-inctence';
import { usePharmacy, writePharmacyPOS } from '../_helper/PharmacyProvider';
import { useLicense } from '../_helper/license/LicenseContext';
import { useLoader } from '../_helper/LoaderContext';
import { toast } from 'react-toastify';

const SSOHandler = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setPharmacyPOS } = usePharmacy();
    const { saveLicenseToken, decodeJWT } = useLicense();
    const { setLoading } = useLoader();

    useEffect(() => {
        const token = searchParams.get('token');

        if (token) {
            handleSSOLogin(token);
        }
    }, [searchParams]);

    const handleSSOLogin = async (ssoToken) => {
        try {
            setLoading(true);
            const response = await axiosInstance.post('healthcare_providers/auth/ssoLogin', {
                token: ssoToken
            });

            if (response.data.status === "success") {
                const pharmacy = response.data.data.healthCareProvider;
                const authToken = response.data.data.token;
                const serverLicenseToken = pharmacy.licenseToken;

                // 1️⃣ Save auth + user (normalize date_format / time_format onto currentPharmacyPOS)
                localStorage.setItem('pharmacyPOSAuth', authToken);
                writePharmacyPOS(pharmacy, setPharmacyPOS, {
                    date_format: pharmacy?.date_format ?? response.data.data?.date_format,
                    time_format: pharmacy?.time_format ?? response.data.data?.time_format,
                    currency: pharmacy?.currency ?? response.data.data?.currency,
                });

                const pharmacyId = pharmacy._id;

                if (serverLicenseToken) {
                    await saveLicenseToken(serverLicenseToken);
                    const decoded = await decodeJWT(serverLicenseToken);

                    const isAllowedUser = decoded?.users?.some(
                        (user) => user.id === pharmacyId
                    );

                    if (isAllowedUser) {
                        toast.success(response.data.message || 'SSO Login successful!');
                        // Remove token from URL and navigate to dashboard
                        navigate(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
                        return;
                    } else {
                        toast.warning('User is not registered with us. Please contact the ClinicDots admin.');
                        localStorage.clear();
                        navigate(`${process.env.PUBLIC_URL}/login`, { replace: true });
                    }
                } else {
                    navigate(`${process.env.PUBLIC_URL}/activate`, { replace: true });
                }

            } else {
                toast.warning(response.data.message || 'SSO Login failed. Invalid token.');
                navigate(`${process.env.PUBLIC_URL}/login`, { replace: true });
            }
        } catch (error) {
            console.error('SSO Login Error:', error);
            // toast.warning(error.message || 'SSO Login failed');
            navigate(`${process.env.PUBLIC_URL}/login`, { replace: true });
        } finally {
            setLoading(false);
        }
    };

    return null; // This component doesn't render anything visible
};

export default SSOHandler;
